module.exports = __webpack_public_path__ + "static/media/youtube.9cbef941.svg";